import React from "react";
// import { useTranslation } from "react-i18next";
import BtnRegisterNow from "../../../assets/images/2026/general/btn-register-now.png";
import OrnamentDotted from "../../../assets/images/2026/general/ornament-dotted.png";
import TextKostradRunTitleSection from "../../../assets/images/2026/general/text-kostrad-run-title-section.png";
import TextTanggalLokasiKostradRun from "../../../assets/images/2026/general/text-tanggal-lokasi-kostrad-run.png";
// import Text5KFunRunKostrad from "../../../assets/images/2026/general/text-5k-fun-run-kostrad.png";
// import Text10KChallengeKostrad from "../../../assets/images/2026/general/text-10k-challenge-kostrad.png";
// import TextTotalHadiah from "../../../assets/images/2026/general/text-total-hadiah.png";
// import BgUangMerah from "../../../assets/images/2026/general/bg-uang-merah.png";
// import Text85Juta from "../../../assets/images/2026/general/text-85-juta.png";
// import Bg5UnitMotor from "../../../assets/images/2026/general/bg-5-unit-motor.png";
// import TextKategori from "../../../assets/images/2026/general/kategori.png";
import Text5kKategori from "../../../assets/images/2026/general/5k.png";
import Text5kUmumPelajar from "../../../assets/images/2026/general/5k-umum-pelajar.png";
import Text10kKategori from "../../../assets/images/2026/general/10k.png";
import Text10kUmumTniPolri from "../../../assets/images/2026/general/10k-umum-tni-polri.png";
import TextHadiahUtama from "../../../assets/images/2026/general/hadiah-utama.png";
import TextTotalHadiah300 from "../../../assets/images/2026/general/total-hadiah.png";
import GambarHadiahUtama from "../../../assets/images/2026/general/hadiah-pc.png";
import TextKategoriNew from "../../../assets/images/2026/general/kategori.png";

export default function KostradRunSection() {
    // const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (
        <div className="w-full max-md:min-h-[70vh] min-h-fit relative">
            <div className="flex flex-col items-center relative">
                <div id="kostrad-run-title-section" className="relative w-full">
                    {/* OrnamentDotted - spans full width, repeats on x-axis */}
                    <div
                        className="w-full h-[80px] md:h-[120px] absolute top-0 left-0 z-10"
                        style={{
                            backgroundImage: `url(${OrnamentDotted})`,
                            backgroundRepeat: 'repeat-x',
                            backgroundSize: 'auto 100%',
                            backgroundPosition: 'center',
                        }}
                    />
                    {/* TextKostradRunTitleSection - centered on top */}
                    <div className="relative z-20 flex justify-center items-center py-4 md:py-8">
                        <img
                            src={TextKostradRunTitleSection}
                            alt=""
                            className="w-[320px] md:w-[420px] h-auto object-contain"
                        />
                    </div>
                </div>
                <div id="kostrad-run-content-section" className="relative w-full flex flex-col md:flex-row pt-4 md:pt-8">
                    {/* TextKostradRunTitleSection - centered on top */}
                    <div className="relative z-20 flex flex-col justify-center items-center py-8 md:basis-1/2" id="kostrad-run-content-section-left">
                        <img
                            src={TextTanggalLokasiKostradRun}
                            alt=""
                            className="w-[240px] md:w-[320px] h-auto object-contain"
                        />
                        <img
                            src={TextKategoriNew}
                            alt=""
                            className="w-[240px] md:w-[240px] h-auto object-contain"
                        />
                        <div className="flex items-center justify-center gap-2 p-8 pb-6 pt-2">
                            <div className="flex flex-wrap items-center justify-center">
                                <img
                                    src={Text5kKategori}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                                <img
                                    src={Text5kUmumPelajar}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                            </div>
                            <div className="flex flex-wrap items-center justify-center">
                                <img
                                    src={Text10kKategori}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                                <img
                                    src={Text10kUmumTniPolri}
                                    alt=""
                                    className="w-[160px] md:w-[240px] h-auto object-contain"
                                />
                            </div>
                        </div>
                        <img
                            src={BtnRegisterNow}
                            alt=""
                            className="w-32 md:w-52 h-auto object-contain cursor-pointer hover:scale-105 transition-all duration-300"
                            onClick={() => window.location.href = "/registration"}
                        />
                    </div>
                    <div className="relative z-20 flex flex-col md:flex-row justify-center items-start py-8 md:basis-1/2" id="kostrad-run-content-section-right">
                        <div className="flex flex-col items-center md:items-start justify-center gap-4">
                            <img
                                src={TextTotalHadiah300}
                                alt=""
                                className="w-[180px] md:w-[320px] h-auto top-8 relative"
                            />
                            {/* <img
                                src={TextTotalHadiah}
                                alt=""
                                className="w-[120px] md:w-[180px] h-auto object-contain top-4 md:top-8 relative"
                            />
                            <div className="relative w-[240px] md:w-[320px] h-[240px] md:h-[320px] -top-8">
                                <img
                                    src={BgUangMerah}
                                    alt=""
                                    className="absolute md:-left-16 inset-0 w-[240px] md:w-[320px] h-[240px] md:h-[320px] object-contain z-10"
                                />
                                <img
                                    src={Text85Juta}
                                    alt=""
                                    className="absolute left-10 md:-left-4 top-8 md:top-6 inset-0 w-[160px] md:w-[240px] h-[160px] md:h-[240px] object-contain z-20"
                                />
                            </div> */}
                            <div className="relative w-[240px] md:w-[320px] h-[240px] md:h-[320px] -top-8 justify-center items-center">
                                <img
                                    src={GambarHadiahUtama}
                                    alt=""
                                    className="absolute top-4 inset-0 w-[240px] md:w-[720px] h-[240px] md:h-[240px] object-contain z-10"
                                />
                                <img
                                    src={TextHadiahUtama}
                                    alt=""
                                    className="absolute top-8 md:top-32 inset-0 w-[160px] md:w-[320px] h-[160px] md:h-[240px] object-contain z-20"
                                />
                            </div>
                        </div>
                        {/* <div className="flex flex-col items-start justify-center gap-4">
                            <img
                                src={Bg5UnitMotor}
                                alt=""
                                className="w-[240px] md:w-[280px] h-auto object-contain pt-4 -top-8 relative"
                            />
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
